import React from 'react'
import { Box } from '@mui/material'

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelCircleIcon from '@mui/icons-material/Cancel';
import HelpCircleIcon from '@mui/icons-material/Help';

import getInitials from '../../utils/getInitials';

// Review SCAN vague 1, point 20 : LE composant de ligne candidat, le seul,
// reutilise par la page « Candidats » et par la page d'une offre. Gabarit de
// la page d'une offre (celui retenu par la review) : nom et email sur une
// ligne, progression avec pourcentage, « Résultat : » + icone + libelle,
// action en fin de ligne. Initiales : 2 caracteres max, en majuscules.
// Candidat sans compte : l'email en ligne principale et « Invitation en
// attente » en ligne secondaire — jamais « — ».

export const infosStatut = (resultForThisUser) => {
  let progress = 0
  let statut = "notStarted"
  let result = "En attente"
  if (resultForThisUser) {
    progress = resultForThisUser?.progress || 0
    if (resultForThisUser?.progress === 100 && resultForThisUser?.isDone === true) {
      statut = "ended"
      result = resultForThisUser?.validationResult === true ? "Compatible" : "Incompatible"
    } else {
      statut = "inProgress"
    }
  }
  return { progress, statut, result }
}

const iconesResultat = {
  "Compatible"   : { Icone : CheckCircleIcon,  couleur : "#38B000" },
  "Incompatible" : { Icone : CancelCircleIcon, couleur : "#FC3040" },
  "En attente"   : { Icone : HelpCircleIcon,   couleur : "black" },
}

const CandidatRow = ({
  nom,           // nom du candidat, absent tant que le compte n'est pas cree
  email,
  compteActive,  // bool — le candidat a cree son compte
  progression,   // 0-100
  statut,        // "notStarted" | "inProgress" | "ended"
  resultat,      // "Compatible" | "Incompatible" | "En attente"
  scanNom,       // optionnel : nom du scan (page « Candidats »)
  clickable,     // bool — bordure au survol + curseur
  onClick,
  action,        // noeud en fin de ligne (chevron, icone mail…)
}) => {
  const { Icone, couleur } = iconesResultat[resultat] || iconesResultat["En attente"]

  return (
    <Box
      onClick={onClick}
      sx={{
        background:"white",
        border:"1px solid #E7E7E7",
        minHeight:["65px", "72px", "72px"],
        padding:"12px",
        display:"flex",
        alignItems:"center",
        gap:["10px", "12px", "12px"],
        userSelect:"none",
        cursor: clickable ? "pointer" : "default",
        "&:hover" : {
          border: clickable ? "1px solid black" : "1px solid #E7E7E7",
        },
      }}
    >
      <Box sx={{
        width:["41px", "48px", "48px"],
        minWidth:["41px", "48px", "48px"],
        height:["41px", "48px", "48px"],
        display:["none", "flex", "flex"],
        background:"black",
        color:"white",
        alignItems:"center",
        justifyContent:"center",
        fontWeight:500,
        fontSize:["14px", "20px", "20px"],
        overflow:"hidden",
      }}>
        {getInitials(compteActive ? nom : email)}
      </Box>

      <Box sx={{
        flex:1,
        overflow:"hidden",
        display:"flex",
        flexDirection:["column", "column", "row"],
        alignItems:["flex-start", "flex-start", "baseline"],
        gap:["2px", "2px", "6px"],
      }}>
        {compteActive ? (
          <>
            <Box sx={{
              fontWeight:500,
              fontSize:["16px", "20px", "20px"],
              color:"text.black",
              whiteSpace:"nowrap",
              overflow:"hidden",
              textOverflow:"ellipsis",
              maxWidth:"100%",
            }}>
              {nom}
            </Box>
            <Box sx={{
              fontWeight:400,
              fontSize:["12px", "16px", "16px"],
              color:"text.primary",
              textOverflow:"ellipsis",
              overflow:"hidden",
              whiteSpace:"nowrap",
              maxWidth:"100%",
            }}>
              {email}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              fontWeight:500,
              fontSize:["16px", "20px", "20px"],
              color:"text.black",
              whiteSpace:"nowrap",
              overflow:"hidden",
              textOverflow:"ellipsis",
              maxWidth:"100%",
            }}>
              {email}
            </Box>
            <Box sx={{
              fontWeight:400,
              fontSize:["12px", "16px", "16px"],
              color:"text.primary",
              whiteSpace:"nowrap",
            }}>
              Invitation en attente
            </Box>
          </>
        )}
      </Box>

      {scanNom &&
        <Box sx={{flex:1, display:["none","none","block"], overflow:"hidden"}}>
          <Box sx={{fontSize:"13px", color:"#565656"}}>Scan</Box>
          <Box sx={{fontSize:"15px", color:"text.black", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis"}}>
            {scanNom}
          </Box>
        </Box>
      }

      <Box sx={{
        display:["none", "flex", "flex"],
        flexDirection:"column",
        width:"250px",
        maxWidth:"250px",
      }}>
        <Box sx={{display:"flex", justifyContent:"space-between", gap:"10px"}}>
          <Box sx={{
            fontWeight:400,
            fontSize:"14px",
            color:"text.primary",
          }}>
            Progression
          </Box>
          <Box sx={{
            fontWeight:400,
            fontSize:"14px",
            color:"text.black",
          }}>
            {statut === "notStarted" ? "--" : `${progression}%`}
          </Box>
        </Box>
        <Box sx={{
          height:"5px",
          marginTop:"5px",
          background:"#D9D9D9",
          position:"relative"
        }}>
          <Box sx={{
            height:"5px",
            background:"black",
            position:"absolute",
            top:0,
            left:0,
            width:`${progression || 0}%`,
          }}/>
        </Box>
      </Box>

      <Box sx={{
        fontWeight:400,
        fontSize:["14px", "14px", "15px"],
        display:"flex",
        alignItems:"center",
        color:couleur,
        gap:"5px",
        justifyContent:"flex-end",
        flexShrink:0,
      }}>
        <Box component="span" sx={{color:"#565656", whiteSpace:"nowrap", display:["none","none","inline"]}}>Résultat&nbsp;:</Box>
        <Icone sx={{width:"20px", height:"20px"}}/>
        <Box component="span" sx={{whiteSpace:"nowrap", color:"black"}}>{resultat}</Box>
      </Box>

      <Box sx={{
        width:["auto", "45px", "45px"],
        minWidth:["auto", "45px", "45px"],
        display:"flex",
        alignItems:"center",
        justifyContent:"center",
      }}>
        {action}
      </Box>
    </Box>
  )
}

export default CandidatRow
